import { Navigate, Route, Routes } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { SupportPage } from "./pages/SupportPage";
import { TermsPage } from "./pages/TermsPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage locale="en" />} />
      <Route path="/zh" element={<LandingPage locale="zh" />} />
      <Route path="/zh-Hant" element={<LandingPage locale="zh-Hant" />} />
      <Route path="/privacy" element={<PrivacyPage locale="en" />} />
      <Route path="/zh/privacy" element={<PrivacyPage locale="zh" />} />
      <Route path="/zh-Hant/privacy" element={<PrivacyPage locale="zh-Hant" />} />
      <Route path="/support" element={<SupportPage locale="en" />} />
      <Route path="/zh/support" element={<SupportPage locale="zh" />} />
      <Route path="/zh-Hant/support" element={<SupportPage locale="zh-Hant" />} />
      <Route path="/terms" element={<TermsPage locale="en" />} />
      <Route path="/zh/terms" element={<TermsPage locale="zh" />} />
      <Route path="/zh-Hant/terms" element={<TermsPage locale="zh-Hant" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
